import { render, staticRenderFns } from "./FormMarsfood.vue?vue&type=template&id=322bd2e6&scoped=true&"
import script from "./FormMarsfood.vue?vue&type=script&lang=js&"
export * from "./FormMarsfood.vue?vue&type=script&lang=js&"
import style0 from "./FormMarsfood.vue?vue&type=style&index=0&id=322bd2e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322bd2e6",
  null
  
)

export default component.exports